/**
 * @format
 * @module bundles/financial-rates
 * @description The bundle for Financial Rates pages
 */
import initFinancialRates from "ui/financial-rates";
import crow from "utils/crow";

/**
 * @method init
 * @description Initializes the Financial Rates pages
 */
function init() {
  initFinancialRates();
}

crow.context(
  {
    feature: "bundle : financial-rates"
  },
  init
);
